import { ICON_PATH } from '@federa/const/icon-svg-paths';
import { createIcon } from '../createIcon.tsx';

export const UploadIcon = createIcon(
	'UploadIcon',
	<>
		<path d={ICON_PATH.TRAY_OPEN_TOP} />
		<polyline points="17 8 12 3 7 8" />
		<line x1="12" y1="3" x2="12" y2="15" />
	</>,
);
